(() => {
  const SETTINGS_SELECTOR = '[data-hallowvia-cookie-settings]';

  function waitForBanner() {
    return new Promise((resolve, reject) => {
      let attempts = 0;
      const check = () => {
        if (typeof window.privacyBanner?.showPreferences === 'function') {
          resolve(window.privacyBanner);
          return;
        }

        attempts += 1;
        if (attempts >= 50) {
          reject(new Error('Cookie preferences unavailable'));
          return;
        }

        window.setTimeout(check, 100);
      };
      check();
    });
  }

  if (window.hallowviaCookieSettingsInitialized) return;
  window.hallowviaCookieSettingsInitialized = true;

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest(SETTINGS_SELECTOR);
    if (!trigger) return;

    event.preventDefault();
    if (trigger.disabled) return;

    trigger.disabled = true;
    trigger.setAttribute('aria-busy', 'true');

    try {
      const banner = await waitForBanner();
      await banner.showPreferences();
    } catch {
      if (trigger.dataset.hallowviaCookieError) {
        window.alert(trigger.dataset.hallowviaCookieError);
      }
    } finally {
      trigger.disabled = false;
      trigger.removeAttribute('aria-busy');
    }
  });
})();
